import { IActivityEngagement } from 'app/api/activityEngagement/model'
import {
  AcademicRankEnum,
  DegreeEnum,
  EthnicGroups,
  UnitEnum,
} from 'app/api/tradeUnionMembers/model'
import { IUnit } from 'app/api/unit/model'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseSpace } from 'app/components/common/BaseSpace'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseInput } from 'app/components/common/inputs/BaseInput'
import { BaseSelect } from 'app/components/common/selects/BaseSelect'
import { usePagination, useRuleHook } from 'app/hook'
import { useGetActivityEngagementList } from 'app/react-query/hook/activityEngagement'
import { useGetSchoolList } from 'app/react-query/hook/school'
import { useGetUnitList } from 'app/react-query/hook/unit'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { DepartmentsEnum, EmploymentStatus, PositionEnum } from '../type'
import R from 'app/assets/R'
import styled from 'styled-components'
import { BaseDatePicker } from 'app/components/common/pickers/BaseDatePicker'
import { Dayjs } from 'dayjs'
import { useGetDegreeList } from 'app/react-query/hook/degree'
import { BaseButton } from 'app/components/common/BaseButton'
import BaseText from 'app/components/common/BaseText'
export interface IFormCreateTradeUnionMember {
  mql?: string
  last_name?: string
  first_name?: string
  gioiTinh?: string
  ngaySinh?: Dayjs
  nguyenQuan?: string
  cmnd?: string
  tenDonVi?: string
  tinhTrangLamViec?: string
  dienThoaiDiDong?: string
  email?: string
  danToc?: string
  tonGiao?: string
  noiOHienNay?: string
  hocHam?: AcademicRankEnum
  hocVi?: DegreeEnum
  tenPhanHieu?: UnitEnum
  ngayVaoUEH?: Dayjs
  ngayVaoCongDoan?: Dayjs
  ngayVaoDang?: Dayjs
  soTheDoanVien?: string
  tinhTrangSinhHoat?: string
  chucVucongdoan?: string
  fullName?: string
  unitId?: string

  schoolId?: string
  activityEngagementId?: string

  file?: string

  degreeId?: string
}
export const useHookCommon = () => {
  const { flattenDataList } = usePagination()
  const {
    data: activityEngagementData,
    isLoading: isLoadingActivityEngagement,
  } = useGetActivityEngagementList({ limit: 1000 })
  const activityEngagement: IActivityEngagement[] = useMemo(() => {
    return flattenDataList(activityEngagementData)?.data ?? []
  }, [activityEngagementData])

  const { data: school, isLoading: isLoadingSchool } = useGetSchoolList({
    limit: 1000,
  })

  const { data: degree, isLoading: isLoadingDegree } = useGetDegreeList({
    limit: 1000,
  })

  return {
    activityEngagement,
    isLoadingActivityEngagement,
    school,
    isLoadingSchool,
    degree,
    isLoadingDegree,
  }
}

export const FormTumCommon = ({
  setEmail,
  disableEditEmail,
  moreExtend,
  reset,
}: {
  setEmail?: (value: string) => void
  disableEditEmail?: boolean
  moreExtend?: React.ReactNode
  reset?: () => void
}) => {
  const { t } = useTranslation()
  const {
    getEmailRule,
    getNumberRule,
    getPhoneRule,
    getStringRule,
    getNormalRule,
  } = useRuleHook()

  const { data: unitData, isLoading: isLoadingUnit } = useGetUnitList({
    limit: 10000,
    page: 1,
  })

  const { flattenDataList } = usePagination()

  const units: IUnit[] = useMemo(() => {
    return flattenDataList(unitData)?.data ?? []
  }, [unitData])

  const {
    school,
    isLoadingSchool,
    activityEngagement,
    isLoadingActivityEngagement,
    degree,
    isLoadingDegree,
  } = useHookCommon()

  return (
    <div style={{ maxHeight: 500, overflowY: 'auto' }}>
      <BaseSpace size={0} style={{ width: '98%' }}>
        <BaseRow justify={'end'} align={'middle'}>
          <BaseButton
            onClick={reset}
            children={<BaseText children={'Reset form'} />}
          />
        </BaseRow>
        <BaseRow align={'top'} justify={'space-between'} gutter={16}>
          <BaseCol xl={8} style={{ flex: 1 }}>
            <BaseForm.Item
              required
              rules={[
                ...getStringRule({
                  field: 'Họ và tên',
                  isRequire: true,
                }),
              ]}
              label={'Họ và tên'}
              name={'fullName'}
            >
              <BaseInput placeholder="Nhập họ và tên" />
            </BaseForm.Item>
          </BaseCol>

          <BaseCol xl={8} style={{ flex: 1 }}>
            <BaseForm.Item
              required
              rules={[
                ...getPhoneRule({
                  field: 'Điện thoại di động',
                  isRequire: true,
                }),
              ]}
              label={'Số điện thoại'}
              name={'dienThoaiDiDong'}
            >
              <BaseInput placeholder="Nhập số điện thoại" />
            </BaseForm.Item>
          </BaseCol>

          <BaseCol xl={8} style={{ flex: 1 }}>
            <BaseForm.Item
              required
              rules={[
                ...getEmailRule({
                  field: 'Email',
                  isRequire: true,
                }),
              ]}
              name={'email'}
              label={'Email'}
            >
              <BaseInput
                placeholder="Nhập email"
                onChange={e => setEmail?.(e?.target?.value ?? '')}
                disabled={disableEditEmail}
              />
            </BaseForm.Item>
          </BaseCol>
        </BaseRow>
        <BaseRow align={'top'} justify={'space-between'} gutter={16}>
          <BaseCol xl={8} style={{ flex: 1 }}>
            <BaseForm.Item
              required
              rules={[
                {
                  required: true,
                  message: 'Vui lòng chọn giới tính',
                },
              ]}
              label={'Giới tính'}
              name={'gioiTinh'}
            >
              <BaseSelect
                style={{ width: '100%' }}
                options={[
                  {
                    label: 'Nam',
                    value: 'Nam',
                  },
                  {
                    label: 'Nữ',
                    value: 'Nữ',
                  },
                ]}
                placeholder="Chọn giới tính"
              />
            </BaseForm.Item>
          </BaseCol>
          <BaseCol xl={8} style={{ flex: 1 }}>
            <BaseForm.Item label={'Mã quản lý'} name={'mql'}>
              <BaseInput placeholder="Nhập mã quản lý" />
            </BaseForm.Item>
          </BaseCol>
          <BaseCol xl={8} style={{ flex: 1 }}>
            <BaseForm.Item
              required
              rules={[
                ...getStringRule({
                  field: 'Quê quán',
                  isRequire: true,
                }),
              ]}
              label={'Quê quán'}
              name={'nguyenQuan'}
            >
              <BaseInput placeholder="nhập đủ 3 cấp Xã/Phường, Huyện/Quận, Tỉnh/Thành phố" />
            </BaseForm.Item>
          </BaseCol>
        </BaseRow>

        <BaseRow align={'top'} justify={'space-between'} gutter={16}>
          <BaseCol xl={8} style={{ flex: 1 }}>
            <BaseForm.Item
              required
              rules={[
                ...getNumberRule({
                  field: 'CMND',
                  isRequire: true,
                }),
                {
                  pattern: new RegExp('^[0-9]{9}$|^[0-9]{12}$'),
                  message: 'CCCD phải có 9 hoặc 12 kí tự',
                },
              ]}
              label={'Căn cước công dân'}
              name={'cmnd'}
            >
              <BaseInput placeholder="Nhập Căn cước công dân" />
            </BaseForm.Item>
          </BaseCol>
          <BaseCol xl={8} style={{ flex: 1 }}>
            <BaseForm.Item
              required
              rules={[
                ...getStringRule({
                  field: 'Tên đơn vị',
                  isRequire: true,
                }),
              ]}
              label={'Đơn vị công tác'}
              name={'tenDonVi'}
            >
              <BaseSelect
                placeholder="Chọn"
                options={Object.values(DepartmentsEnum).map(department => ({
                  label: department,
                  value: department,
                }))}
                showSearch
                allowClear
              />
            </BaseForm.Item>
          </BaseCol>
          <BaseCol xl={8} style={{ flex: 1 }}>
            <BaseForm.Item
              required
              rules={[
                ...getStringRule({
                  field: 'Tình trạng làm việc',
                  isRequire: true,
                }),
              ]}
              label={'Tình trạng làm việc'}
              name={'tinhTrangLamViec'}
            >
              <BaseSelect
                placeholder="Chọn"
                options={Object.values(EmploymentStatus).map(val => ({
                  label: val,
                  value: val,
                }))}
                showSearch
                allowClear
              />
            </BaseForm.Item>
          </BaseCol>
        </BaseRow>

        <BaseRow align={'top'} justify={'space-between'} gutter={16}>
          <BaseCol xl={8} style={{ flex: 1 }}>
            <BaseForm.Item
              label={'Dân tộc'}
              name={'danToc'}
              rules={[
                ...getNormalRule({
                  field: 'Dân tộc',
                  isRequire: true,
                }),
              ]}
              required
            >
              <BaseSelect
                options={Object.values(EthnicGroups).map(item => ({
                  label: item,
                  value: item,
                }))}
                filterSort={() => 0}
                showSearch
                placeholder="Chọn dân tộc"
                allowClear
              />
            </BaseForm.Item>
          </BaseCol>
          <BaseCol xl={8} style={{ flex: 1 }}>
            <BaseForm.Item
              label={'Tôn giáo'}
              name={'tonGiao'}
              required
              rules={[
                ...getNormalRule({
                  field: 'Tôn giáo',
                  isRequire: true,
                }),
              ]}
            >
              <BaseInput placeholder="Nếu không có, điền: Không" />
            </BaseForm.Item>
          </BaseCol>
          <BaseCol xl={8} style={{ flex: 1 }}>
            <BaseForm.Item
              required
              rules={[
                ...getStringRule({
                  field: 'Nơi ở hiện nay',
                  isRequire: true,
                }),
              ]}
              label={'Địa chỉ'}
              name={'noiOHienNay'}
            >
              <BaseInput placeholder="Nhập địa chỉ" />
            </BaseForm.Item>
          </BaseCol>
        </BaseRow>

        <BaseRow align={'top'} justify={'space-between'} gutter={16}>
          <BaseCol xl={8} style={{ flex: 1 }}>
            <BaseForm.Item label={'Học hàm'} name={'hocHam'}>
              <BaseSelect
                options={Object.values(AcademicRankEnum).map(item => ({
                  label: item,
                  value: item,
                }))}
                filterSort={() => 0}
                showSearch
                placeholder="Chọn học hàm"
                allowClear
              />
            </BaseForm.Item>
          </BaseCol>
          <BaseCol xl={8} style={{ flex: 1 }}>
            <BaseForm.Item label={'Học vị'} name={'degreeId'}>
              <BaseSelect
                options={degree?.data?.map(item => ({
                  label: item?.name,
                  value: item?.id,
                }))}
                filterSort={() => 0}
                showSearch
                placeholder="Chọn học vị"
                allowClear
                loading={isLoadingDegree}
              />
            </BaseForm.Item>
          </BaseCol>
          <BaseCol xl={8} style={{ flex: 1 }}>
            <BaseForm.Item label={'Ngày vào UEH'} name={'ngayVaoUEH'}>
              <Picker
                picker={'date'}
                allowClear={false}
                placeholder="Nhập ngày vào UEH"
                format={'DD/MM/YYYY'}
              />
            </BaseForm.Item>
          </BaseCol>
        </BaseRow>

        <BaseRow align={'top'} justify={'space-between'} gutter={16}>
          <BaseCol xl={8} style={{ flex: 1 }}>
            <BaseForm.Item
              label={'Ngày vào công đoàn'}
              name={'ngayVaoCongDoan'}
            >
              <Picker
                picker={'date'}
                allowClear={false}
                placeholder="Nhập ngày vào công đoàn"
                format={'DD/MM/YYYY'}
              />
            </BaseForm.Item>
          </BaseCol>

          <BaseCol xl={8} style={{ flex: 1 }}>
            <BaseForm.Item
              rules={[
                ...getNormalRule({
                  field: 'Tên công đoàn bộ phận',
                }),
              ]}
              label={'Tên công đoàn bộ phận'}
              name={'schoolId'}
            >
              <BaseSelect
                options={school?.data?.map(item => ({
                  label: item?.name,
                  value: item?.id,
                }))}
                filterSort={() => 0}
                showSearch
                placeholder={'Chọn'}
                loading={isLoadingSchool}
              />
            </BaseForm.Item>
          </BaseCol>
          <BaseCol xl={8} style={{ flex: 1 }}>
            <BaseForm.Item
              label={'Ngày sinh'}
              name={'ngaySinh'}
              required
              rules={[
                {
                  required: true,
                  message: 'Vui lòng chọn ngày sinh',
                },
              ]}
            >
              <Picker
                picker={'date'}
                allowClear={false}
                placeholder="Nhập ngày sinh"
                format={'DD/MM/YYYY'}
              />
            </BaseForm.Item>
          </BaseCol>
        </BaseRow>

        <BaseRow align={'top'} justify={'space-between'} gutter={16}>
          <BaseCol xl={8} style={{ flex: 1 }}>
            <BaseForm.Item
              rules={[
                ...getNumberRule({
                  field: 'Số thẻ đoàn viên',
                }),
              ]}
              label={'Số thẻ đoàn viên'}
              name={'soTheDoanVien'}
            >
              <BaseInput placeholder="Nhập số thẻ đoàn viên" />
            </BaseForm.Item>
          </BaseCol>
          <BaseCol xl={8} style={{ flex: 1 }}>
            <BaseForm.Item label={'Ngày vào Đảng'} name={'ngayVaoDang'}>
              <Picker
                picker={'date'}
                allowClear={false}
                placeholder="Nhập ngày vào Đảng"
                format={'DD/MM/YYYY'}
              />
            </BaseForm.Item>
          </BaseCol>
          <BaseCol xl={8} style={{ flex: 1 }}>
            <BaseForm.Item
              required
              rules={[
                {
                  message: t(R.strings.require_field, {
                    field: 'Tình trạng sinh hoạt',
                  }),
                  required: true,
                },
              ]}
              label={'Tình trạng sinh hoạt'}
              name={'activityEngagementId'}
            >
              <BaseSelect
                placeholder="Chọn tình trạng sinh hoạt"
                options={activityEngagement?.map(item => ({
                  label: item?.name,
                  value: item?.id,
                }))}
                loading={isLoadingActivityEngagement}
                showSearch
                allowClear
              />
            </BaseForm.Item>
          </BaseCol>
          <BaseCol xl={24}>
            <BaseForm.Item label={'Đơn vị công đoàn'} name={'unitId'}>
              <BaseSelect
                placeholder={'Chọn'}
                options={units?.map(unit => ({
                  label: `${unit?.name}`,
                  value: unit?.id,
                }))}
                showSearch
                loading={isLoadingUnit}
              />
            </BaseForm.Item>
          </BaseCol>
          <BaseCol xl={24}>
            <BaseForm.Item
              label={t(R.strings.union_positions)}
              required
              rules={[
                ...getNormalRule({
                  field: 'Chức vụ công đoàn',
                  isRequire: true,
                }),
              ]}
              name={'chucVucongdoan'}
            >
              <BaseSelect
                placeholder={'Chọn'}
                options={Object.values(PositionEnum).map(position => ({
                  label: position,
                  value: position,
                }))}
                showSearch
                mode="multiple"
              />
            </BaseForm.Item>
          </BaseCol>
        </BaseRow>

        {moreExtend}
      </BaseSpace>
    </div>
  )
}

export const Picker = styled(BaseDatePicker)`
  width: 100%;
`
